import script from "./pendingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./pendingModal.vue?vue&type=script&setup=true&lang=js"

import "./pendingModal.vue?vue&type=style&index=0&id=2466af4c&lang=scss"

const __exports__ = script;

export default __exports__